const BaseCategoryPage = require('base/category-page');
const Server = require('helper/server');
const { advancedSearch } = require('helper/search');

const searchlTpl = Handlebars.templates['templates/search-tpl'];
const advancedSearchlTpl = Handlebars.templates['templates/advanced-search-tpl'];
class Category extends BaseCategoryPage {
  search () {
    const { showContent, code } = this.selectedTreeNode;
    const { articleId, PID, districtCode } = this.query.params;
    this.$content.find('.block__content').spin(); // 搜索前先旋转
    // 五种情况:后台详情预览、展示详情、展示列表、采购公告
    if (showContent && this.previewFlag) {
      this.renderPreview({ categoryCode: code, articleId, PID });
    } else if (showContent) {
      this.renderDetail({ code });
    } else if (code.toLowerCase() === 'todaybidopen') { // 今日开标特殊处理
      const currentTime = new Date();
      const end = currentTime.getTime();
      const begin = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate()).getTime();
      // let payload = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize,
      //   end,
      //   begin
      // };
      // this.client.searchAnnoucement(payload)
      //   .done((...res) => this.renderList(...res));
      let payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
        // publishDateEnd: end,
        // publishDateBegin: begin
      };
      Server.getTodayBid(payload).then((res) => {
        // console.log(res);
        // debugger;
        this.renderList(res);
      });
    } else {
      // let payload = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize,
      //   code
      // };
      // $.extend(payload, this.query.params);
      // // 公告区划采前四位模糊匹配
      // if (districtCode && typeof districtCode === 'string') {
      //   delete payload.districtCode;
      //   payload.wildcardDistrictCode = districtCode.slice(0, 4) + '*';
      // }
      // console.log(payload);
      // this.client
      //   .searchArticleByKeyWord(payload)
      //   .done((...res) => this.renderList(...res));
      let payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        categoryCode: code
      };
      $.extend(payload, this.query.params);

      this.query.params.begin && (payload.publishDateBegin = moment(+this.query.params.begin).format('YYYY-MM-DD'));
      this.query.params.end && (payload.publishDateEnd = moment(+this.query.params.end).format('YYYY-MM-DD'));

      this.query.params.begin && delete payload.begin;
      this.query.params.end && delete payload.end;
      console.log(payload);
      if (!payload.districtCode) {
        delete payload.districtCode;
      } else {
        typeof this.query.params.districtCode === "string" ? (payload.districtCode = payload.districtCode.split(',')) : (payload.districtCode = payload.districtCode)
      }
      Server.searchCategory(payload).done((res) => {
        this.renderList(res);
      });
    }
  }

  initSearchPanel () {
    const { showContent = false, code } = this.selectedTreeNode;
    if (showContent) {
      this.$searchPanel.html('');
    } else if (code.includes('ZcyAnnouncement')) {
      this.$searchPanel.html(advancedSearchlTpl);
    } else {
      this.$searchPanel.html(searchlTpl);
    }
  }

  /**
   * 公告高级搜索
   */
  async advancedSearch () {
    advancedSearch.apply(this);
  }
}

module.exports = Category;
